const tr = {
  packs:{
    attributes:{
      id: 'ID',
      name: 'Nome',
      description: 'Descrição',
      packages: 'Adicionais',
      specialties: 'Especialidades',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
    },
    extras:{
      create: 'Novo pacote',
      edit: 'Editando pacote',
      show: 'Visualizando pacote',
      delete: 'Excluir pacote',
      noPackages: 'Não há adicionais vinculadas',
      noSpecialties: 'Não há especiliadades vinculadas',
    },
    defSingular: 'Pacote',
    defPlural: 'Pacotes',
  }
};

export default tr;
